export default __webpack_public_path__ + "static/media/WOR-metaphor2.f78f8dd9.png";